// PATH: src/App.jsx
// App.jsx
import { useEffect } from "react";
import { RouterProvider } from "react-router";
import { AuthProvider } from "app/contexts/auth/Provider";
import { AuthModalProvider } from "app/contexts/authModal/Provider";
import { BreakpointProvider } from "app/contexts/breakpoint/Provider";
import { LocaleProvider } from "app/contexts/locale/Provider";
import { SidebarProvider } from "app/contexts/sidebar/Provider";
import { ThemeProvider } from "app/contexts/theme/Provider";
import AxiosInterceptor from "components/AxiosInterceptor";
import { registerSiteVisit, needsSiteVisit } from "utils/siteVisit";

import router from "app/router/router";

function App() {
  // visit is recorded once per tab (not on reload); retried until the server accepts it
  useEffect(() => {
    registerSiteVisit();
  }, []);

  // earlier tries failed, or site data was cleared while the tab is open:
  // try again when the user comes back to the tab or the network returns
  useEffect(() => {
    const recheck = () => {
      if (document.visibilityState === "visible" && needsSiteVisit()) {
        registerSiteVisit();
      }
    };
    document.addEventListener("visibilitychange", recheck);
    window.addEventListener("focus", recheck);
    window.addEventListener("online", recheck);
    return () => {
      document.removeEventListener("visibilitychange", recheck);
      window.removeEventListener("focus", recheck);
      window.removeEventListener("online", recheck);
    };
  }, []);

  return (
    <AuthProvider>
      <AuthModalProvider>
      <ThemeProvider>
        <LocaleProvider>
          <BreakpointProvider>
            <SidebarProvider>
           
          
            
              {/* ✅ Only wrap inside RouterProvider */}
              <RouterProvider
          
                router={router}  
                fallbackElement={
                  <AxiosInterceptor>
                    <div>Loading...</div>
                  </AxiosInterceptor> 
                 
                }
              /> 
            </SidebarProvider>
          </BreakpointProvider>
        </LocaleProvider>
      </ThemeProvider>
      </AuthModalProvider>
    </AuthProvider>

  );
}

export default App;